import { cubicBezier, MotionDurations, MotionEasings, } from '@polestar/component-warehouse-react/tokens/motion/Motion';
import Colors, { withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
const CardTheme = {
    card: {
        light: {
            states: {
                enabled: {
                    color: Colors.black,
                    motionEase: cubicBezier(MotionEasings.ease),
                    motionDuration: MotionDurations.fast,
                },
                hover: {
                    color: withOpacity(Colors.black, Opacities.medium),
                    buttonIconColor: Colors.accessibleSafetyOrange,
                    motionEase: cubicBezier(MotionEasings.ease),
                    motionDuration: MotionDurations.normal,
                },
            },
        },
        dark: {
            states: {
                enabled: {
                    color: Colors.white,
                    motionEase: cubicBezier(MotionEasings.ease),
                    motionDuration: MotionDurations.fast,
                },
                hover: {
                    color: withOpacity(Colors.white, Opacities.medium),
                    buttonIconColor: Colors.accessibleSafetyOrange,
                    motionEase: cubicBezier(MotionEasings.ease),
                    motionDuration: MotionDurations.normal,
                },
            },
        },
    },
};
export default CardTheme;
